// extracted by mini-css-extract-plugin
export var container = "_80-0";
export var icon = "_80-1";
export var text = "_80-2";